// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_fc-0";
export var fileCarousel = "_fc-2";
export var removeFileButton = "_fc-1";